import { createElement } from "react";
import {
  siWhatsapp,
  siWechat,
  siTripadvisor,
  siTiktok,
  siThreads,
  siTelegram,
  siSnapchat,
  siReddit,
  siPinterest,
  siYoutube,
  siX,
  siInstagram,
  siFacebook,
  siDiscord,
} from "simple-icons";

// lucide-react 1.x removed brand glyphs (Instagram, Facebook, ...). We restore
// the common social brands from simple-icons, wrapped so they accept the same
// props lucide icons do (size, color). Icons are imported by name (not via a
// namespace import) so the bundler tree-shakes the 3000+ icon package down to
// only what we use. Keys are the icon_map values Strapi stores. Brands
// simple-icons has dropped for trademark reasons (LinkedIn, Twitter)
// intentionally fall through to the DynamicIcon fallback.
const BRAND_TO_SIMPLE_ICON = {
  Instagram: siInstagram,
  Facebook: siFacebook,
  X: siX,
  Youtube: siYoutube,
  YouTube: siYoutube,
  Tiktok: siTiktok,
  TikTok: siTiktok,
  Whatsapp: siWhatsapp,
  WhatsApp: siWhatsapp,
  Telegram: siTelegram,
  Pinterest: siPinterest,
  Snapchat: siSnapchat,
  Threads: siThreads,
  Wechat: siWechat,
  WeChat: siWechat,
  Discord: siDiscord,
  Reddit: siReddit,
  Tripadvisor: siTripadvisor,
  TripAdvisor: siTripadvisor,
};

const buildBrandIcon = (icon) => (props) => {
  const size = props.size || 24;
  return createElement(
    "svg",
    {
      role: "img",
      viewBox: "0 0 24 24",
      width: size,
      height: size,
      fill: props.color || "currentColor",
      ...props,
    },
    createElement("title", null, icon.title),
    createElement("path", { d: icon.path }),
  );
};

export const getBrandIcon = (iconName) => {
  const icon = BRAND_TO_SIMPLE_ICON[iconName];
  if (!icon) {
    return null;
  }
  return buildBrandIcon(icon);
};
